export class NewFeedbackReply {
  public reply = "";
  public userFeedbackId = "";
}
